import type { MrmStateFE } from 'domain/vehicle';
import { useMemo } from 'react';

import type { MRMStateValue } from 'API';

const useMRMProcess = (value?: MRMStateValue | MrmStateFE | null) => {
    const { isPerformingMRM, isMRC, isReleasingMRC } = useMemo(
        () => ({
            isPerformingMRM: value === 'EXECUTING_MRM',
            isMRC: value === 'MRC',
            isReleasingMRC: value === 'RELEASING_MRC',
        }),
        [value]
    );

    const isLoading = isPerformingMRM || isReleasingMRC;

    if (!value || value === 'NONE') {
        return {
            isMRC: false,
            isPerformingMRM: false,
            isReleasingMRC: false,
            isLoading: false,
        };
    }

    return {
        isMRC,
        isPerformingMRM,
        isReleasingMRC,
        isLoading,
    };
};

export default useMRMProcess;
